import { render } from "./LegalServices.vue?vue&type=template&id=76ad1160"
import script from "./LegalServices.vue?vue&type=script&lang=js"
export * from "./LegalServices.vue?vue&type=script&lang=js"

import "./LegalServices.vue?vue&type=style&index=0&id=76ad1160&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__